
import { Vue, Component } from 'vue-property-decorator';
import Forecast from '@/ui/components/devices/previews/mpc/PVProductionService/Forecast.vue';
import Chart from '@/ui/components/devices/previews/mpc/PVProductionService/Chart.vue';

@Component({
  components: {
    Forecast,
    Chart,
  },
})
export default class SettingsCharts extends Vue {
  tab: any = null

  get settingsViewLang() {
    return 'mlModel.PVProductionService.settingsView.chartTabs';
  }

  get tabs() {
    return [
      {
        title: 'Chart',
        locale: this.settingsViewLang,
        component: 'Chart',
      },
      {
        title: 'Forecast',
        locale: this.settingsViewLang,
        component: 'Forecast',
      },
    ];
  }
}
